import { render } from "./headerlogo.vue?vue&type=template&id=74ba062a&scoped=true"
import script from "./headerlogo.vue?vue&type=script&lang=js"
export * from "./headerlogo.vue?vue&type=script&lang=js"

import "./headerlogo.vue?vue&type=style&index=0&id=74ba062a&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ba062a"]])

export default __exports__